import { AxiosPromise } from 'axios';
import * as GamesProvider from '../../providers/games/gamesProvider';

const gamesApiInstance = new GamesProvider.GamesApi();
const gamePassesApiInstance = new GamesProvider.GamePassesApi();

const getGameDetails = (
  universeIds: number[]
): AxiosPromise<GamesProvider.RobloxWebWebAPIModelsApiArrayResponseRobloxGamesApiModelsResponseGameDetailResponse> => {
  return gamesApiInstance.v1GamesGet(universeIds, { withCredentials: true });
};

const getGamePasses = (
  universeId: number,
  sortOrder?: 'Asc' | 'Desc',
  limit?: 10 | 25 | 50 | 100,
  cursor?: string
): AxiosPromise<GamesProvider.RobloxWebWebAPIModelsApiPageResponseRobloxGamesApiModelsResponseGamePassResponse> => {
  return gamePassesApiInstance.v1GamesUniverseIdGamePassesGet(universeId, sortOrder, limit, cursor);
};

const getGamesSorts = (
  modelGameSortsContext?:
    | 'GamesDefaultSorts'
    | 'GamesAllSorts'
    | 'HomeSorts'
    | 'ChatSorts'
    | 'UnifiedHomeSorts'
    | 'AbTestSorts'
    | 'GamesPageAbTestSorts1'
    | 'GamesPageAbTestSorts2'
): AxiosPromise<GamesProvider.RobloxGamesApiModelsResponseGameSortsResponse> => {
  return gamesApiInstance.v1GamesSortsGet(modelGameSortsContext);
};

const getGamesList = (
  modelSortToken?: string,
  modelGameFilter?: string,
  modelTimeFilter?: string,
  modelGenreFilter?: string,
  modelExclusiveStartId?: number,
  modelSortOrder?: number,
  modelGameSetTargetId?: number,
  modelKeyword?: string,
  modelStartRows?: number,
  modelMaxRows?: number,
  modelIsKeywordSuggestionEnabled?: boolean,
  modelContextCountryRegionId?: number,
  modelContextUniverseId?: number,
  modelPageId?: string,
  modelSortPosition?: number,
  options?: any
): AxiosPromise<GamesProvider.RobloxGamesApiModelsResponseGamesSearchResponse> => {
  return gamesApiInstance.v1GamesListGet(
    modelSortToken,
    modelGameFilter,
    modelTimeFilter,
    modelGenreFilter,
    modelExclusiveStartId,
    modelSortOrder,
    modelGameSetTargetId,
    modelKeyword,
    modelStartRows,
    modelMaxRows,
    modelIsKeywordSuggestionEnabled,
    modelContextCountryRegionId,
    modelContextUniverseId,
    modelPageId,
    modelSortPosition,
    options
  );
};

export default {
  getGameDetails,
  getGamePasses,
  getGamesSorts,
  getGamesList
};
